import { NgModule } from '@angular/core';

import { IsVisibleDirective } from '~shared/directives/is-visible/is-visible.directive';

@NgModule({
  exports: [IsVisibleDirective],
  declarations: [IsVisibleDirective],
})
export class IsVisibleModule {
}
